import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Input } from "@/components/ui/input";
import { useState } from "react";
import { FiUser } from "react-icons/fi";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import CharacterMenu from "components/CharacterMenu/CharacterMenu";
import useApp from "hooks/useApp";

export default function Edit({
  setScreen,
  user,
  update,
  uploadPicture,
  error,
  loading,
}: any) {
  const [name, setName] = useState(user?.fullName || "");
  const [phoneNumber, setPhoneNumber] = useState(user?.phoneNumber || "");
  const [fileId, setFileId] = useState<number | null>(null);
  const [showCharacterHasChanged, setShowCharacterHasChanged] = useState(false);
  const { setUser } = useApp();
  const [original, setOriginal] = useState({
    name: user?.fullName || "",
    phoneNumber: user?.phoneNumber || "",
  });

  const handleUpdate = async (data: { name: string; phoneNumber: string }) => {
    await update(data, fileId);
    setOriginal(data); // update "original" so it doesn’t keep resubmitting
  };

  const handleBlur = (field: "name" | "phoneNumber") => {
    if (field === "name" && name !== original.name) {
      handleUpdate({ name, phoneNumber });
    }
    if (field === "phoneNumber" && phoneNumber !== original.phoneNumber) {
      handleUpdate({ name, phoneNumber });
    }
  };

  const handleFile = async (event: any) => {
    const fileUploaded = event.target.files[0];
    const ProfilePictureFileModuleType: number = 2;
    const tempFormData = new FormData();
    tempFormData.append(`file`, fileUploaded);

    const response: any = await uploadPicture(
      ProfilePictureFileModuleType,
      tempFormData
    );
    if (response.status === 200) {
      const allfiles = response.data;
      setFileId(allfiles[0].uniqueId);
    }
  };

  const onCharacterConfirm = (name: string) => {
    setShowCharacterHasChanged(true);
    setUser((prev: any) => ({
      ...prev,
      characterName: name
    }));
  };

  return (
    <div className="h-full rounded-md w-full">
      <div className="bg-midnight rounded-mdp-1 2xl:p-3 2xl:pb-1 flex flex-col gap-3 w-full h-full">
        {error && <div>{error}</div>}

        <div className="w-full h-full p-2">
          <form className="w-full h-full">
            <div className="flex justify-between w-full gap-4 h-full">
              <div className="pt-2 w-[25%] max-w-[25%] h-full flex flex-col gap-2">
                <div className="h-min w-full flex flex-wrap justify-between gap-2">
                  {user?.picture ? (
                    <Avatar className="w-32 h-32 2xl:w-40 2xl:h-20 rounded-full">
                      <AvatarImage src={user?.picture} alt="Avatar" />
                      <AvatarFallback></AvatarFallback>
                    </Avatar>
                  ) : (
                    <div className="2xl:w-40 2xl:h-40 w-32 h-32 grid place-content-center bg-dark rounded-full mx-auto">
                      <FiUser size={80} />
                    </div>
                  )}
                  <Input
                    id="picture"
                    className="input placeholder:text-white cursor-pointer"
                    type="file"
                    onChange={handleFile}
                  />
                  <div className="flex flex-wrap w-full">
                    <span className="w-full text-center">{name}</span>
                    <span className="w-full text-center text-white/45 text-sm">
                      Developer
                    </span>
                  </div>
                  {/* <div className="min-h-6 w-full">
                      {loading && <div>Updating Profile...</div>}
                      {error && <div>{error}</div>}
                    </div> */}
                </div>
                <div className="mx-auto pb-2 flex-1">
                  <div className="z-50 bg-dark w-max h-max rounded-xl relative">
                    <CharacterMenu onCharacterConfirm={onCharacterConfirm} />
                    {showCharacterHasChanged &&
                      <div className="absolute top-2 w-full flex items-center">
                        <p className="text-blue mx-auto text-xs">Character has been changed</p>
                      </div>
                    }
                  </div>
                </div>
              </div>

              {/* Editable fields */}
              <div className="w-[75%] max-w-[75%] h-full flex items-center justify-center">
                <div className="flex gap-4 h-[75%] justify-center items-center">
                  <div className="flex flex-wrap w-1/3 h-full gap-4">
                    <div className="py-2 w-full flex flex-wrap h-max">
                      <label
                        className="text-white/70 text-md w-full"
                        htmlFor="Name"
                      >
                        Name
                      </label>
                      <input
                        disabled
                        className="bg-transparent border-white/30 pb-1 w-full"
                        name="email"
                        value={name}
                      />
                    </div>

                    {/* email */}
                    <div className="py-2 w-full flex flex-wrap h-max">
                      <label
                        className="text-white/70 text-md w-full"
                        htmlFor="email"
                      >
                        Email
                      </label>
                      <input
                        disabled
                        className="bg-transparent border-white/30 pb-1 w-full"
                        name="email"
                        value={user.email}
                      />
                    </div>

                    <div className="py-2 w-full flex flex-wrap h-max">
                      <label
                        className="text-white/70 text-md w-full"
                        htmlFor="organization"
                      >
                        Organization Name
                      </label>
                      <span className="bg-transparent border-white/30 pb-1 w-full">
                        SDAIA NIC
                      </span>
                    </div>
                  </div>

                  <div className="flex flex-wrap w-1/3 h-full gap-4">
                    <div className="py-2 w-full flex flex-wrap h-max">
                      <label className="text-white/70 text-md w-full">
                        Joined On
                      </label>
                      <span className="bg-transparent border-white/30 pb-1 w-full">
                        07 NOV 2025
                      </span>
                    </div>
                    <div className="py-2 w-full flex flex-wrap h-max">
                      <label className="text-white/70 text-md w-full">
                        Total no of projects
                      </label>
                      <span className="bg-transparent border-white/30 pb-1 w-full">
                        2
                      </span>
                    </div>
                    <div className="py-2 w-full flex flex-wrap h-max">
                      <label className="text-white/70 text-md w-full">
                        Subscription Status
                      </label>
                      <span className="text-green bg-transparent border-white/30 pb-1 w-full">
                        Active
                      </span>
                    </div>
                  </div>

                  <div className="flex flex-wrap w-1/3 h-full gap-4">
                    <div className="py-2 w-full flex flex-wrap h-max">
                      <label className="text-white/70 text-md w-full">
                        Subscription Type
                      </label>
                      <span className="bg-transparent border-white/30 pb-1 w-full text-green">
                        Perpetual License
                      </span>
                    </div>

                    <div className="py-2 w-full h-max">
                      <label className="text-white/70 text-md flex justify-start gap-10 items-center">
                        <span>Password</span>
                        <div
                          className="cursor-pointer text-green text-xs xl:text-md flex items-center justify-center"
                          onClick={() => setScreen("passwords")}
                        >
                          Change Password
                        </div>
                      </label>
                      {/* <input
                        disabled
                        className="bg-transparent border-b-2 border-white/30 pb-1 w-full tracking-widest"
                        name="password"
                        value="password"
                        type="password"
                      /> */}
                    </div>

                    {/* phone number */}
                    <div className="py-2 w-full h-max">
                      <label
                        className="text-white/70 text-[12px]"
                        htmlFor="skype"
                      >
                        Phone Number
                      </label>
                      <PhoneInput
                        country={"uae"}
                        value={phoneNumber}
                        onChange={(phone) => setPhoneNumber(phone)}
                        onBlur={() => handleBlur("phoneNumber")}
                        containerClass="!bg-transparent !max-w-full"
                        inputClass="!bg-transparent !max-w-full"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
